import { getBusinessEntities } from './get-business-entities';
import { BusinessEntityType } from '@grc/ui-shared/lib/components/models/enums/enums';

interface FetchBusinessEntitiesParams {
  fetchData: any;
  entityIds: string[];
  setData?: (data: any) => void;
  entityType?: BusinessEntityType;
  status?: boolean;
}

export const fetchBusinessEntities = async ({
  fetchData,
  entityIds,
  setData,
  entityType = BusinessEntityType.AccountSupplier,
  status = true
}: FetchBusinessEntitiesParams) => {
  if (!entityIds.length) return {};

  const res = await getBusinessEntities(fetchData, {
    status,
    locationIds: entityIds
    //entityType
  });

  const items: any[] = res?.data ?? [];

  // Set data if setter function is provided
  if (setData && items.length > 0) {
    setData(items[0]);
  }

  // Create map for easy lookup
  const map: any = {};
  for (const e of items) if (e?.id) map[e.id] = e;

  return {
    items,
    map,
    firstItem: items[0]
  };
};
